export const tenant_data = {
  aws_upload_bucket: null,
  upload_filename_format: null,
  info: null
}